import { Fragment, useEffect, useState } from "react";
import {
    Card,
    Col,
    Container,
    Input,
    Label,
    Row,
} from "reactstrap";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import { ReportListTitle, ReportOVPTitle, ReportTitle } from "../../Utils/Constants";
import CommonTable from "../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { ensureDexieReady, getFieldValuesFromDexie, getFilteredPositionIds } from "../../db/DexieServises";
import MonthDropdown from "../CommonCompo/MonthDropdown";
import { useParams, useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import CommonTableNew from "../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Utils";
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-toolkit/store';

export default function OVPReport() {
    const { positionId } = useParams(); // from route
    const location = useLocation();
    const selectedMonths = location.state?.selectedMonth; // from state

    const convertToMonthYear = (dateStr: string) => {
        const [year, month] = dateStr.split("-");
        return `${month}-${year}`;
    };
    const result = convertToMonthYear(selectedMonths);
    // console.log(result); // 👉 "06-2025"
    // console.log(positionId, result, '===========show');

    const [searchText, setSearchText] = useState('');
    const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
    const [effortData, setEffortData] = useState<any[]>([]);
    const [displayedData, setDisplayedData] = useState<any[]>([]);
    const [selectedMonth, setSelectedMonth] = useState<string>('');
    const [loading, setLoading] = useState(true);

    // 🔥 Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const unitId = useSelector((state: RootState) => state.orgUnit.id);

    useEffect(() => {
        if (result) {
            handleSubmitAPI();
        }
    }, [result, selectedIds, unitId]);

    const handleSubmitAPI = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }
        await ensureDexieReady();

        const ids = await getFilteredPositionIds('Position', unitId);
        const positionIds = selectedIds.length > 0 ? selectedIds : (ids ? ids : []);
        const month = result;

        // console.log("📦 API Call Payload:OVP", {
        //     position_id: positionId,
        //     moye: month
        // });

        const url = `${serverUrl}${API.getOvpReport}`;
        const { status, data } = await getData(url, true, {
            position_id: positionId,
            moye: month,
        });

        if (status === 200 && Array.isArray(data?.data)) {
            setEffortData(data?.data);
            setLoading(false); // 👈 Stop loader
        } else {
            setEffortData([]);
        }
        setCurrentPage(1); // 🔥 Reset to first page on new data
        setLoading(false); // 👈 Stop loader
    };

    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = effortData.filter((item) =>
            item?.EmployeeName?.toLowerCase().includes(lower) ||
            item?.Town?.toLowerCase().includes(lower) ||
            item?.Patch?.toLowerCase().includes(lower) ||
            item?.Speciality?.toLowerCase().includes(lower) ||
            item?.EmployeeLevel?.toLowerCase().includes(lower) ||
            item?.DoctorName?.toLowerCase().includes(lower)
        );
        setDisplayedData(filtered);
        setCurrentPage(1); // 🔥 Reset page on search
    }, [searchText, effortData]);


    const keys = displayedData.length > 0 ? Object.keys(displayedData[0]) : [];
    const headData = keys.map((key, index) => ({
        id: `${index + 1}`,
        head: key,  // Optional: Make header labels more readable
        key: key,
        sortKey: key             // You can set this to `null` if sorting isn't needed
    }));

    // 🔥 Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = displayedData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(displayedData.length / rowsPerPage);
    const handleExportToExcel = () => {
        const exportData = displayedData.map((row: Record<string, any>) => {
            const rowData: Record<string, any> = {};
            keys.forEach(key => {
                rowData[key] = row[key];
            });
            return rowData;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'OVP Report');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `OVP_Export_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    return (
        <div className='page-body p-2'>
            <Card>
                <div className='d-flex justify-content-between align-items-center  pb-1'>
                    <CardHeaderSpan headingClassName='pb-0 pt-0' back={true} heading={ReportOVPTitle} span={ReportListTitle} />
                    <div className='p-3'>
                        <Row className="align-items-center justify-content-end mb-3">

                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Col xs="auto">
                                    <Input
                                        type="text"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder="Search by Employee Name"
                                    />
                                </Col>
                                <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                                    <FeatherIconCom iconName="Download" size={14} className="text-light" />
                                    <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                                </button></div>

                        </Row>
                        {/* <MonthDropdown onChange={(value) => setSelectedMonth(value)} /> */}
                    </div>
                </div>

                <Fragment>
                    <Container fluid>
                        <div className='d-flex justify-content-between align-items-center'>
                            {/* <Row className="align-items-center justify-content-end mb-3">
                                <Col xs="auto">
                                    <Label>{'Search'}:</Label>
                                </Col>
                                <Col xs="auto">
                                    <Input
                                        type="text"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder="Search by Employee Name"
                                    />
                                </Col>
                            </Row> */}
                            <div className="d-flex align-items-center">
                                {/* <TreeModel onSelectionChange={setSelectedIds} /> */}
                            </div>
                        </div>

                        <Row>
                            <Col sm={12}>
                                <div className="table-responsive">
                                    {/* <CommonTable caption="" headData={headData}>
                                        {currentRows.length === 0 ? (
                                            <tr>
                                                <td colSpan={headData.length} className="text-center">
                                                    No data found.
                                                </td>
                                            </tr>
                                        ) : (
                                            currentRows.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {keys.map((key, colIndex) => (
                                                        <td key={colIndex}>{(row as Record<string, any>)[key]}</td>
                                                    ))}
                                                </tr>
                                            ))
                                        )}
                                    </CommonTable> */}
                                    {loading ? (
                                        <div className="text-center py-3">
                                            {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
                                            <div>
                                                <Image
                                                    className="b-r-10 img-80"
                                                    src={dynamicImage('dashboard/loader.gif')}
                                                    alt="Loading..."
                                                />
                                            </div>
                                        </div>
                                    ) : (

                                        <CommonTableNew
                                            caption=""
                                            headData={headData}
                                            data={displayedData}
                                            // rowsPerPage={10}
                                            renderRow={(row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {keys.map((key, colIndex) => (
                                                        <td key={colIndex}>{(row as Record<string, any>)[key]}</td>
                                                    ))}
                                                </tr>
                                            )}></CommonTableNew>)}
                                </div>


                            </Col>
                        </Row>
                    </Container>
                </Fragment>
            </Card>
        </div>
    );
}
